import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GatesService } from 'src/app/services/gates.service';
import { AddGateComponent } from '../add-gate/add-gate.component';
import { MainService } from 'src/app/services/main.service';
import { VillageService } from 'src/app/services/village.service';
import { AddVillageConfigComponent } from '../add-village-config/add-village-config.component';
import { AddUserConfigComponent } from '../add-user-config/add-user-config.component';
import { UnitsService } from 'src/app/services/units.service';
import { AddQrConfigComponent } from '../add-qr-config/add-qr-config.component';
@Component({
  selector: 'app-main-gates',
  templateUrl: './main-gates.component.html',
  styleUrls: ['./main-gates.component.css']
})
export class MainGatesComponent {
  gates_arr: any = [];

  village_list: any;
  
   userObj = {
    name: '',
    type : '',
    anti_passback: false,
    applying_quota: false,
    owner_existence : false,
    vip_access : false
  };
  villageObj = {
    name: '',
    kids: false,
    rented: false
  };
  qrObject = {
    name: '',
    type:'',
    started : '',
    ended : '',
    one_time_use : ''
  }
  types_arr:any
  slectedVillage: any = "all";
  selected_user_village: any = 'all'
  selected_type:any = 'all'
  selectedQr_type:any;
  selected_qr_village:any
  types_qr_arr : any
  constructor(
    public dialog: MatDialog,
    private mainServ: MainService,
    private villageSer: VillageService,
    private unitServ : UnitsService,
    private rest: GatesService
  ) {}

  ngOnInit() {
    this.retriveGates();
    this.retive_all_villages();
  }

  // gates
  retriveGates() {
    this.rest.retriveGates().subscribe((res: any) => {
      console.log(res);
      this.gates_arr = res;
    });
  }
  addGate() {
    const dialogRef = this.dialog.open(AddGateComponent, {
      width: '450px'
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      console.log(res);
      if (res) {
        this.rest.addGate(res).subscribe((res: any) => {
          console.log(res);
          this.mainServ.SuccessToast('Gate added successfully');
          this.retriveGates();
        });
      }
    });
  }
  // end gates

  // village config

  retive_all_villages() {
    this.villageSer.villageList().subscribe((res: any) => {
      console.log(res);
      this.village_list = res;
      // this.slectedVillage = res[0];
      // this.selected_user_village = res[0];
      this.selected_qr_village = res[0]
      res.forEach((element:any) => {
        this.retriveVillagesConfig(element);
      });
      this.users_type()
      this.qr_type()
    });
  }

 villages_arr_table : any = []
  retriveVillagesConfig(item: any) {
    this.villageSer.retriveVillageConfig(item.id).subscribe((res: any) => {
      console.log(res);
      res.name = item.name
      this.villages_arr_table.push(res)
      console.log("villages_arr_table",this.villages_arr_table)
    });
  }

  add_village_config() {
    const dialogRef = this.dialog.open(AddVillageConfigComponent, {
      width: '450px'
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      console.log(res);
      if (res) {
        this.villageSer.addVillageConfig(res).subscribe((res: any) => {
          console.log(res);
          this.mainServ.SuccessToast('Config added successfully');
        });
      }
    });
  }

  villageChnage(e: any) {
    this.villages_arr_table = []
    if(e.value == "all"){
      this.village_list.forEach((element:any) => {
        this.retriveVillagesConfig(element);
      });
    }else {
      this.retriveVillagesConfig(e.value);
    }
    console.log(this.slectedVillage);
  }

  // end village

  // users config

 users_list_arr : any = [] 
  users_type(){
    this.unitServ.unitRelation().subscribe((res: any) => {
      console.log("unit relation" , res)
      this.types_arr = res.children
      // this.selected_type = this.types_arr[0]
      for(let i = 0 ; i < this.village_list.length ; i ++){
        for(let j = 0 ; j < this.types_arr.length ; j++){
          this.retrive_user_config(this.types_arr[j],this.village_list[i])
        }
      }
    })
  }

  changeType(e:any){
    this.users_list_arr = []
    if(e.value == "all"){
      if(this.selected_user_village == "all"){
        for(let i = 0 ; i < this.village_list.length ; i ++){
          for(let j = 0 ; j < this.types_arr.length ; j++){
            this.retrive_user_config(this.types_arr[j],this.village_list[i])
          }
        }
      }else {
        for(let i = 0 ; i < this.types_arr.length ; i ++){
          this.retrive_user_config(this.types_arr[i],this.selected_user_village)
        }
      }
    }else {
      if(this.selected_user_village == "all"){
        for(let i = 0 ; i < this.village_list.length ; i ++){
          this.retrive_user_config(e.value,this.village_list[i])
        }
      }else {
        this.retrive_user_config(e.value,this.selected_user_village)
      }
    }
  }

  village_user_Chnage(e: any) {
    this.users_list_arr = []
    console.log(e.value)
    if(e.value == "all"){
      console.log("1")
      if(this.selected_type == "all"){
        console.log("1 , 1")
        for(let i = 0 ; i < this.village_list.length ; i ++){
          for(let j = 0 ; j < this.types_arr.length ; j++){
            this.retrive_user_config(this.types_arr[j],this.village_list[i])
          }
        }
      }else {
        console.log("1, 2")
        for(let i = 0 ; i < this.village_list.length ; i ++){
          this.retrive_user_config(this.selected_type,this.village_list[i])
        }
      }
    }else {
      if(this.selected_type == "all"){
        console.log("2")
        for(let i = 0 ; i < this.types_arr.length ; i ++){
          this.retrive_user_config(this.types_arr[i],e.value)
        }
      }else {
        this.retrive_user_config(this.selected_type,e.value)
      }
    }
  }
  
  retrive_user_config(type:any,village:any) {
    this.rest.retive_user_config(type.id,village.id).subscribe((res:any) => {
      console.log(res)
      res.name = village.name
      res.type = type.name
      this.users_list_arr.push(res)
    })

  }



  add_user_config() {
    const dialogRef = this.dialog.open(AddUserConfigComponent, {
      width: '450px'
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      console.log(res);
      if (res) {
        this.rest.addUserConfig(res).subscribe((res: any) => {
          console.log(res);
          this.mainServ.SuccessToast('User Config added successfully');
        });
      }
    });
  }

  // qr config

  add_qr_config() {
    const dialogRef = this.dialog.open(AddQrConfigComponent, {
      width: '450px'
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      console.log(res);
      if (res) {
        this.rest.addQrConfig(res).subscribe((res: any) => {
          console.log(res);
          this.mainServ.SuccessToast('Qr Config added successfully');
        });
      }
    });
  }

  qr_type(){
    this.unitServ.qrtypes().subscribe((res: any) => {
      console.log(res)
      this.types_qr_arr = res.children
      this.selectedQr_type = this.types_qr_arr[0]
      this.retrive_qr_config(this.selectedQr_type.id,this.selected_qr_village.id)
    })
  }

  changeQrType(e:any){
    this.retrive_qr_config(e.value.id,this.selected_qr_village.id)
  }

  village_qr_Chnage(e: any) {
    console.log(e.value)
    this.retrive_qr_config(this.selectedQr_type.id,e.value.id)
  }
  retrive_qr_config(type:any,village:any) {
    this.qrObject.name = this.selected_qr_village.name
    this.qrObject.type = this.selectedQr_type.name
    this.rest.retive_user_config(type,village).subscribe((res:any) => {
      console.log(res)
      this.qrObject.one_time_use = res.one_time_use
      this.qrObject.started = res.started
      this.qrObject.ended = res.ended
    })
  }
}
